/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type loginOnelogin_viewer$ref = any;
export type loginOnelogin_QueryVariables = {||};
export type loginOnelogin_QueryResponse = {|
  +viewer: ?{|
    +component: ?string,
    +$fragmentRefs: loginOnelogin_viewer$ref,
  |}
|};
export type loginOnelogin_Query = {|
  variables: loginOnelogin_QueryVariables,
  response: loginOnelogin_QueryResponse,
|};
*/


/*
query loginOnelogin_Query {
  viewer {
    component(name: "login_onelogin")
    ...loginOnelogin_viewer
    id
  }
}

fragment loginOnelogin_viewer on Viewer {
  id
  actualPersonId
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "login_onelogin"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"login_onelogin\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "loginOnelogin_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "loginOnelogin_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "loginOnelogin_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actualPersonId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "loginOnelogin_Query",
    "operationKind": "query",
    "text": "query loginOnelogin_Query {\n  viewer {\n    component(name: \"login_onelogin\")\n    ...loginOnelogin_viewer\n    id\n  }\n}\n\nfragment loginOnelogin_viewer on Viewer {\n  id\n  actualPersonId\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4c7105b30011b23ad0e23b6d0441001c';

module.exports = node;
